export type ConnectivitySnapshot = {
  online: boolean
}

export class ConnectivityMonitor {
  readonly #listeners = new Set<(snapshot: ConnectivitySnapshot) => void>()
  #lastOnline = navigator.onLine
  #pollTimer: number | null = null
  readonly #onChange = () => {
    const snapshot = this.getSnapshot()
    this.#lastOnline = snapshot.online
    for (const listener of this.#listeners) listener(snapshot)
  }

  readonly #poll = () => {
    if (navigator.onLine !== this.#lastOnline) this.#onChange()
  }

  getSnapshot(): ConnectivitySnapshot {
    return { online: navigator.onLine }
  }

  subscribe(listener: (snapshot: ConnectivitySnapshot) => void): () => void {
    if (this.#listeners.size === 0) {
      window.addEventListener('online', this.#onChange)
      window.addEventListener('offline', this.#onChange)
      this.#pollTimer = window.setInterval(this.#poll, 1_000)
    }
    this.#listeners.add(listener)
    return () => {
      this.#listeners.delete(listener)
      if (this.#listeners.size === 0) {
        window.removeEventListener('online', this.#onChange)
        window.removeEventListener('offline', this.#onChange)
        if (this.#pollTimer !== null) window.clearInterval(this.#pollTimer)
        this.#pollTimer = null
      }
    }
  }
}
